import LoginUser from '@modules/husleie-framework/src/types/LoginUser.entity';
import PhoneNumber from '@modules/husleie-framework/src/types/PhoneNumber.entity';

const enum UserRoleEnum {
  LANDLORD = 'landlord',
  TENANT = 'tenant',
}
type UserRole = UserRoleEnum.LANDLORD | UserRoleEnum.TENANT;

interface User extends LoginUser {
  id?: null | number;
  title?: string;
  appellation?: string;
  firstName: string;
  lastName: string;
  fullName: string;
  mobilePhone?: PhoneNumber;
  dateOfBirth?: string;
  placeOfBirth?: string;
  role: undefined | UserRole;
}

export { User, UserRole, UserRoleEnum };
